var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseTag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.10124 7L13.8837 1.21751C14.1328 0.976246 13.9538 0.555984 13.6113 0.555984H12.514C12.4128 0.555984 12.3116 0.594898 12.2416 0.672724L7.01167 5.90265L1.76618 0.672724C1.69614 0.60268 1.59497 0.555984 1.49379 0.555984H0.38866C0.0462246 0.555984 -0.132776 0.976246 0.116268 1.21751L5.89876 7L0.116268 12.7825C-0.132776 13.0315 0.0462246 13.444 0.38866 13.444H1.48601C1.58718 13.444 1.68836 13.4051 1.7584 13.3273L6.98833 8.09735L12.2182 13.3273C12.2883 13.3973 12.3895 13.444 12.4906 13.444H13.588C13.9382 13.444 14.1094 13.0238 13.8604 12.7825L8.07789 7H8.10124Z",
    fill: "#AABBCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseTag);
export default __webpack_public_path__ + "static/media/CloseTag.7767ca32f2fedcc2b28af070b2adc50b.svg";
export { ForwardRef as ReactComponent };